import { Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router, NavigationExtras} from "@angular/router";
import {MatSnackBar} from '@angular/material/snack-bar';
import {Location} from '@angular/common';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {Title} from "@angular/platform-browser";
import { ManagementServiceService } from 'src/app/management-service.service';
import { B2BService } from 'src/app/b2-b.service';
import { DomSanitizer } from '@angular/platform-browser';

import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css']
})
export class ManagementComponent implements OnInit {

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

setLanguage(language: string){
    if (localStorage){
        localStorage['language'] = language;
    }
}

  constructor(private titleService:Title, private sanitizer: DomSanitizer, private managementService:ManagementServiceService, public B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _snackBar: MatSnackBar, private location: Location) {
    
    this.titleService.setTitle("Automotive 2.0");
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');
  
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  
      // Debounce search.
      this.searchTermUpdate.pipe(
        debounceTime(500),
        distinctUntilChanged())
        .subscribe(value => {
          // this.GetSearchResults(value);
        });
   }

  public BackendServiceUrl = this.service.APIUrl;
  public ElasticLogo = "";
  public MongoLogo = "";

  ngOnInit(): void {

    this.showContent = false;
    this.TestEnviorment();
    this.TestNetConnection();
    this.SetDefaultLanguage();
    this.User = JSON.parse(localStorage.getItem("User"));
    this.ElasticLogo = this.BackendServiceUrl + '/Images/Brands/ELASTIC_LOGO.png';
    this.MongoLogo = this.BackendServiceUrl + '/Images/Brands/mongo.png';
 
    if(this.User == null){
     this.RedirectToURLWithUrlChange('login');
    }
    else{
 
      if(this.User.LastLogin == null || this.User.LastLogin?.length == 0){
        this.LogOff();
      }

     this.User.Rights.AssignedCompanies.forEach(element => {
       if(element.IsSelected == true){
         this.Company = element;
       }
 
       this.SearchResultTypes = this.User.Settings.SearchResultTypes.filter(x => x.IsSelected == true && x.ID != 0);
       this.SearchInProducts = this.User.Settings.SearchInProducts;
     });

     if(this.Company == null){
      this.RedirectToURLWithUrlChange('login/success/company/select');
     }

        //get master data
   var request = {
    User:this.User,
    Language:this.getLanguage()
 };

 this.loading = true;

 this.service.GetMasterData(request).subscribe(response => {

   if(response["Status"] != 1){
   
   }
   else if(response["Status"] == 1){
    this.masterData = response;
    this.Applications = response["Applications"];
    this.OrderTypes = response["OrderTypes"];
    this.RightTypes = response["RightTypes"];
    this.GetSetApplicationByUrl();
   }

   this.loading = false;
   this.GetMainCurrency();
   
 },
 (err) => {
  this.translate.get("ServerConnectionError").subscribe((resource: string) => {
    this.loading = false;
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
    this.CurrentApp = this.User?.Rights?.Application;
  });
 });

   this.CompanyNotificationPager = {
     PageIndex:1,
     PageSize:50,
     Pages:0,
     TotalCount:0
   };
    this.CompanyNotificationOnlyUnSeen = null;

     this.GetUserAssignedCompanies();
    this.SendEmailWithAttachment = true;
    this.GetCompanyNotificationsFilteredCOUNT(false, true);
    this.GetUserManagementInfo();
    this.GetUserManagerUnreadOffers();

    // Initialize B2B Grid data
    this.GetB2BMasterData();
    this.GetB2BUserConnectedPartner(this.User);
    this.Cart = { Items: [] };
    }
  }

  ShowLogisticsMenu:boolean = false;
  ShowOrdersMenu:boolean = false;
  ShowQuotationsMenu:boolean = false;
  ShowTasksMenu:boolean = false;
  ShowProductsMenu:boolean = false;
  ShowSettingsMenu:boolean = false;
  ShowPartnersMenu:boolean = false;

  OpenCloseMenu(menu:string){
    if(menu == "Logistics"){
      this.ShowLogisticsMenu = !this.ShowLogisticsMenu;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
      this.ShowPartnersMenu = false;  
    }
    else if(menu == "Orders"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = !this.ShowOrdersMenu;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
      this.ShowPartnersMenu = false;
    }
    else if(menu == "Quotations"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = !this.ShowQuotationsMenu;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
      this.ShowPartnersMenu = false;
    }
    else if(menu == "Tasks"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = !this.ShowTasksMenu;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
      this.ShowPartnersMenu = false;
    }
    else if(menu == "Products"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = !this.ShowProductsMenu;
      this.ShowSettingsMenu = false;
      this.ShowPartnersMenu = false;
    }
    else if(menu == "Settings"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = !this.ShowSettingsMenu;
      this.ShowPartnersMenu = false;
    }
    else if(menu == "Partners"){
      this.ShowLogisticsMenu = false;
      this.ShowOrdersMenu = false;
      this.ShowQuotationsMenu = false;
      this.ShowTasksMenu = false;
      this.ShowProductsMenu = false;
      this.ShowSettingsMenu = false;
      this.ShowPartnersMenu = !this.ShowPartnersMenu;
    }
  }

SendEmailWithAttachment:boolean;
CompanyNotificationOnlyUnSeen:boolean;
UnseenCompanyNotificationPager:boolean;
CompanyNotifications:any[];
CompanyNotificationPager:any;
masterData:any;
searchTermUpdate = new Subject<string>();
ShowAppsSelect:boolean = false;
Applications:any[];
CurrentApp:any;
AuxCurrentApp:any;
LocalEnviormentWithLiveAPIWarning:boolean = false;
User:any;
Company:any;
SearchResultTypes:any[];
SearchInProducts:boolean;
loading:boolean;
initialLoad:boolean;
mainCurrency:any;
isSearchActive:boolean;
showContent:boolean;
showLoggOffContainer:boolean;
OrderTypes:any[];
RightTypes:any[];

OfferRequestsPager:any;
OfferRequests:any[];
UnsolvedIndividualItemsCount:number;

// B2B Grid Properties
Cart: {[k: string]: any} = {};
B2BPartner:any;
B2BAgent:any;
CartMasterData:any;
B2BUserTrackingEventTypes:any[];
OfferRequest: {[k: string]: any} = {}; // ⚠️ Used for OfferRequests functionality
Offer: {[k: string]: any} = {}; // ✅ Used for Offers functionality (quotations/new)
RelevantAgents:any[] = [];

// Reference to track PDF export events - will be set by child component
private trackPDFExportCallback: (() => void) | null = null;

selectAllText(event: any) {
  event.target.select();
}

OnlyNumbers($event: any): boolean {
  var event = $event as KeyboardEvent;
  const charCode = event.which ? event.which : event.keyCode;

  // Allow control keys: backspace, delete, arrow keys, etc.
  const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', ',', '.'];
  if (controlKeys.includes(event.key)) {
    return true;
  }

  // Allow numbers 0-9
  if (charCode >= 48 && charCode <= 57) {
    return true;
  }

  // Prevent default action for other keys
  event.preventDefault();
  return false;
}

GetCompanyNotificationsFilteredCOUNT(IsSeen:boolean, firstLoad:boolean){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Pager:this.CompanyNotificationPager,
    IsSeen:IsSeen
  };

  this.loading = true;

  this.service.GetCompanyNotificationsFilteredCOUNT(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CompanyNotificationPager = response["Pager"];

      if(firstLoad){
        this.UnseenCompanyNotificationPager = response["Pager"];
      }
    }
   
    this.loading = false;
  });
}

GetUserAssignedCompanies(){

  var request = {
    User:this.User,
    Language:this.getLanguage()
 };

 this.loading = true;

 this.service.GetUserAssignedCompanies(request).subscribe(response => {

   if(response["Status"] != 1){
   
   }
   else if(response["Status"] == 1){
     this.User.Rights.AssignedCompanies = response["AssignedCompanies"];
   }

   this.loading = false;
   
 });
}

GetMainCurrency(){
  this.mainCurrency = this.Company?.Addresses[0]?.Country?.Currency;
}

openSnackBar(message: string, action: string, designClass: string, duration:number = 5000) {
  this._snackBar.open(message, action, {
    duration: duration,
    panelClass: [designClass]
  });
}

CloseDashMenu(){
  this.isSearchActive = false;
}

SetDefaultLanguage(){

  if(this.getLanguage() == ''){
    this.setLanguage("en");
  }
}

TestEnviorment(){

  var fullpath = this.router['location']._platformLocation.location.origin;

  if((!this.service.APIUrl.includes("localhost") || !this.managementService.APIUrl.includes("localhost")) && fullpath.includes("localhost")){
    this.LocalEnviormentWithLiveAPIWarning = true;
  }
}

TestNetConnection(){

  if(navigator.onLine == false){
    this.translate.get("OfflineConnection").subscribe((resource: string) => {
      this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
    });
   }
}

getUrlWithoutParams(){
  let urlTree = this.router.parseUrl(this.router.url);
  urlTree.queryParams = {}; 
  return urlTree.toString();
}

GetSetApplicationByUrl(){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams()
  };

  this.loading = true;

 this.service.GetSetApplicationByUrl(request).subscribe(response => {

   if(response["Status"] != 1){
    this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
    var currentURL = response["URL"];
    this.CurrentApp = currentURL.Application;
    
    this.User.Rights.Application = currentURL.Application;
    this.User.AppAccess.forEach(AppAccess => {
      if(AppAccess.Application.ID == this.CurrentApp.ID){
        AppAccess.IsSelected = true;
      }
      else{
        AppAccess.IsSelected = false;
      }
    });

    localStorage.setItem('User', JSON.stringify(this.User));

    if(this.User.Rights.Application.RequiresToken == true){
      let MFATokenCookie:any = this.cookieService.get('MFAuthToken');

      if(!MFATokenCookie){
        this.RedirectToURLWithUrlChange('login/MFA');
      }
    }
   }

   this.CheckUserRouteAccess();
   this.loading = false;
 },
 (err) => {
  this.translate.get("AppIdentificationError").subscribe((resource: string) => {
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
  });
 });

}

CheckUserRouteAccess(){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams(),
  };

  this.loading = true;

 this.service.CheckUserRouteAccess(request).subscribe(response => {

   if(response["Status"] != 1){
    this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){

    if(response["HasAccess"] == true && response["CurrentAppAccess"] == true){
      this.showContent = true;
    }
    else{
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");

      setTimeout(() => {
        window.location.replace('login');
      }, 2000);
    }
   }

   this.initialLoad = false;
   this.loading = false;
 },
 (err) => {
  this.translate.get("ServerConnectionError").subscribe((resource: string) => {
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
  });
 });

}

RedirectToURLWithUrlChange(url: string) {
  if (this.router.url === url) {
    // Force a full page reload
    window.location.href = url;
  } else {
    // Navigate normally
    this.router.navigate([url], { replaceUrl: true });
  }
}

OpenAppsSelect(){
  this.AuxCurrentApp = JSON.parse(JSON.stringify(this.CurrentApp));
  this.ShowAppsSelect = true;
}

AuxCompany:any;
ShowCompanySelect:boolean;

OpenCompanySelect(){
  this.AuxCompany = JSON.parse(JSON.stringify(this.Company));
  this.ShowCompanySelect = true;
}

SwitchApplication(){
  this.CurrentApp = JSON.parse(JSON.stringify(this.AuxCurrentApp));
  this.UpdateUserLastSelectedApplication(this.CurrentApp);
}

UpdateUserLastSelectedApplication(App:any){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    UserID:this.User.Id,
    ApplicationID:App.ID
  };

  this.loading = true;

  this.service.UpdateUserLastSelectedApplication(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.User.Rights.Application = JSON.parse(JSON.stringify(App));
      this.User.AppAccess.forEach(AppAccess => {
        if(AppAccess.Application.ID == App.ID){
          AppAccess.IsSelected = true;
        }
        else{
          AppAccess.IsSelected = false;
        }
      });

      localStorage.setItem('User', JSON.stringify(this.User));
      this.RedirectToURLWithUrlChangeNewTab(App.MainURL);
      this.ShowAppsSelect = false;
    }
 
    this.loading = false;
  });
}

RedirectToURLWithUrlChangeNewTab(url:string){
  window.open(url, '_blank');
}

compareMultipleFn(o1: any, o2: any): boolean {
  
  // if possible compare by object's name property - and not by reference.
  return o1 && o2 ? o1.ID === o2.ID : o2 === o2;
}

compareFn(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

OpenLogOff(){
  this.showLoggOffContainer = true;
}

LogOff(){
  this.loading = true;
  localStorage.removeItem("User");
  this.cookieService.delete("MFAuthToken", "/");
  window.location.reload();
}

ReloadPage(){
  window.location.reload();
}

UpdateUserLastUsedCompany(CompanyID:number){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    LastUsedCompanyID:CompanyID,
    UserID:this.User.Id
  };

  this.loading = true;

  this.service.UpdateUserLastUsedCompany(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.RedirectToURLWithUrlChange(this.CurrentApp.MainURL);
    }
   
    this.loading = false;
  });
}

ChangeMainCompany(company:any){

  this.User.Rights.AssignedCompanies.forEach(element => {
    element.IsSelected = false;

    if(element.ID == company.ID){
      element.IsSelected = true;
    }

    localStorage.setItem('User', JSON.stringify(this.User));
    this.Company = company;
    this.UpdateUserLastUsedCompany(company.ID);
  });

  this.ShowCompanySelect = false;
}

signature:any;

GetUserManagementInfo(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams()
  };

  this.loading = true;

  this.service.GetUserManagementInfo(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      this.RedirectToURLWithUrlChange("management/personal/settings");
    }
    else if(response["Status"] == 1){
      this.User.UserManagementInfo = response["UserManagementInfo"];
      this.signature = this.sanitizer.bypassSecurityTrustHtml(this.User.UserManagementInfo?.SignatureModel);
    }
   
    this.loading = false;
  });
}

newGuid() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxxxxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

GetUserManagerUnreadOffers(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams(),
    WithCount:true
  };

  this.B2BService.GetUserManagerUnreadOffers(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.OfferRequestsPager = response["Pager"];
      this.OfferRequests = response["OfferRequests"];
      this.UnsolvedIndividualItemsCount = response["UnsolvedInidivdualItems"];
    }
  });
}

printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

GoToDocumentPage(DocumentID:string, DirectionID:number, CompanyID:number){

  var SearchResultType = 0;

  if(DirectionID == 1){
    SearchResultType = 2;
  }
  else if(DirectionID == -1){
    SearchResultType = 1;
  }

  const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['dashboard/document/view'], { queryParams: { DocumentID: DocumentID, TypeID: SearchResultType, Company:CompanyID } }));
  window.open(nextUrl, '_blank');
}

// ========== B2B GRID FUNCTIONS ==========

// Method for child component to register PDF export tracking callback
registerPDFExportCallback(callback: () => void): void {
  this.trackPDFExportCallback = callback;
}

GetCart(){
  this.Cart = JSON.parse(localStorage.getItem("AdminQuotationCart"));
}

UpdateCart(isRedRowEdit: boolean = false){
  localStorage.setItem('AdminQuotationCart', JSON.stringify(this.Cart));
}

GetB2BMasterData(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
  };

  this.loading = true;

  this.B2BService.GetB2BMasterData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CartMasterData = JSON.parse(JSON.stringify(response));
      // Filter out ShippingServiceType with ID == 2
      if(this.CartMasterData.ShippingServiceTypes){
        this.CartMasterData.ShippingServiceTypes = this.CartMasterData.ShippingServiceTypes.filter(x => x.ID != 2);
      }
      this.B2BUserTrackingEventTypes = this.CartMasterData.B2BUserTrackingEventTypes;
    }

    this.loading = false;
  });
}

GetB2BUserConnectedPartner(user:any){

  var request = {
    User:user,
    Language:this.getLanguage(),
  };

  this.B2BService.GetB2BUserConnectedPartner(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.B2BPartner = response["Partner"];
      this.GetB2BUserConnectedAgent();
    }
  });
}

GetB2BUserConnectedAgent(){

  var request = {
    User:this.User,
    Settings:this.User.Settings,
    Language:this.getLanguage(),
  };

  this.B2BService.GetB2BUserConnectedAgent(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.B2BAgent = response["Agent"];
      this.RelevantAgents = response["RelevantAgents"];
    }
  });
}

AddNewOffer(POButtonPressed:boolean = false, cart:any = null){
  if(this.loading != true){

   if(!cart){
    this.GetCart();
   }
   else{
    this.Cart = JSON.parse(JSON.stringify(cart));
   }

   this.OfferRequest.UserUploader = this.User;
   this.OfferRequest.AgentManager = this.B2BAgent;
   this.OfferRequest.Company = this.Company;
   this.OfferRequest.Cart = this.Cart;
   this.OfferRequest.Type = this.CartMasterData.OrderTypes[4];
   this.OfferRequest.PaymentType = this.Cart.PaymentType;
   this.OfferRequest.DeliveryPreference = this.Cart.DeliveryPreference;

   var request = {
     User:this.User,
     Language:this.getLanguage(),
     OfferRequest:this.OfferRequest,
     POButtonPressed:POButtonPressed,
   };

   this.loading = true;

   return this.B2BService.AddNewOfferRequest(request).toPromise().then(response => {

     if(response["Status"] != 1){
       this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
       var OfferRequest = response["OfferRequest"];
       localStorage.removeItem("Cart");
       this.GoToRequestOfferConfirmation(OfferRequest.ID);
     }

     this.loading = false;
     return response;
    });
  }
 }

 DownloadOfficialOffer(){

   this.OfferRequest.UserUploader = this.User;
   this.OfferRequest.AgentManager = this.B2BAgent;
   this.OfferRequest.Company = this.Company;
   this.OfferRequest.Cart = this.Cart;
   this.OfferRequest.Type = this.CartMasterData.OrderTypes[4];
   this.OfferRequest.PaymentType = this.Cart.PaymentType;

   var request = {
     User:this.User,
     Language:this.getLanguage(),
     OfferRequest:this.OfferRequest,
   };

   this.loading = true;

   this.B2BService.DownloadOfficialOffer(request).subscribe(response => {

     if(response["Status"] != 1){
       this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     }
     else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);

        // Track PDF export event - notify child component
        if (this.trackPDFExportCallback) {
          this.trackPDFExportCallback();
        }
     }

     this.loading = false;
    });
 }

 GoToRequestOfferConfirmation(RequestOfferID:any){
  this.router.navigate(['management/quotations/offer/request/confirmation'], { queryParams: { RequestOfferID: RequestOfferID } });
}

InitializeExitBlockedAccount(message:string){
  // this.openSnackBar(message, "OK", "alert-info-snackbar", 60000);
  // setTimeout(() => this.LogOff(), 10000);
}

// Stub methods for AG Grid component compatibility (not used in AG Grid version)
itemOverlay: boolean = false;

hasSearchResults(): boolean {
  return false; // AG Grid doesn't use this old cart system
}

closeSearchResults(): void {
  // AG Grid doesn't use this old cart system
}

CloseItemOverlay(): void {
  this.itemOverlay = false;
}

SMTPConfigs:any[];
CurrenctSMTP:any;
SMTPEmails:any[];

GetCompanySMTPConfigsForOrders(o){
  var request = {
    User:this.User,
    Language:o.Cart.Partner.BillingAddress.Country.Language.Name,
    UILanguage:this.getLanguage(),
    CompanyID:this.Company.ID
  };

  this.loading = true;

  this.service.GetCompanySMTPConfigs(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPConfigs = response["SMTPConfigs"];

      if(this.SMTPConfigs.length > 0){
        this.CurrenctSMTP = this.SMTPConfigs[0];
        this.GetCompanySMTPEmails(this.CurrenctSMTP.ID, o);
      }
    }
   
    this.loading = false;
  });
}

CurrentSMTPEmail:any;
EmailMessage:any;
CurrentOrder:any;

GetCompanySMTPEmails(SMTPID:any, o:any){
  var request = {
    User:this.User,
    Language:o.Cart.Partner.BillingAddress.Country.Language.Name,
    UILanguage:this.getLanguage(),
    SMTPID:SMTPID
  };

  this.loading = true;
  this.CurrentOrder = o;

  this.service.GetCompanySMTPEmails(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPEmails = response["Emails"];

      if(this.SMTPEmails.length > 0){
        this.CurrentSMTPEmail = this.SMTPEmails?.filter(x => x.IsDefault == true)[0];

        if(this.CurrentSMTPEmail == null){
          this.CurrentSMTPEmail = this.SMTPEmails[0];
        }

        this.EmailMessage.GeneralDocType = o.GeneralDocType;
        this.EmailMessage.EmailModel = {};
        this.EmailMessage.EmailModel = this.CurrentSMTPEmail;
        this.EmailMessage.DocumentID = o.ID;
        this.EmailMessage.SMTPServer = this.CurrenctSMTP.SMTPServer;
        this.EmailMessage.Port = this.CurrenctSMTP.Port;

        this.GenerateOrderDocumentEmailSubject(o);
      }
    }

    this.loading = false;
  });
}

GenerateOrderDocumentEmailSubject(order:any){
  var request:any = {
    User:this.User,
    Language:order.Cart?.Partner?.BillingAddress?.Country?.Language?.Name ?? this.getLanguage(),
    GeneralDocType: order.GeneralDocType
  };

  // Set the appropriate order type property based on GeneralDocType
  // eGeneralDocType: Offer = 16, OfferRequest = 12, OrderConfirmation = 14, PurchaseOrder = 15
  switch (order.GeneralDocType) {
    case 16: // Offer
      request.Offer = order;
      break;
    case 12: // OfferRequest
      request.OfferRequest = order;
      break;
    case 14: // OrderConfirmation
      request.OrderConfirmation = order;
      break;
    case 15: // PurchaseOrder
      request.PurchaseOrder = order;
      break;
  }

  this.loading = true;

  this.managementService.GenerateOrderDocumentEmailSubject(request).subscribe(response => {

    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.EmailMessage.EmailModel.Subject = response["Subject"];
      this.EmailMessage.EmailModel.DefaultMessage = response["Body"];
      this.EmailMessage.ToEmail = response["ToEmail"];
    }

    this.loading = false;
  });
}

}
